import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { IInvoicingService } from '../model/invoicing-service';
import { Observable } from 'rxjs/Observable';
import { IPerson } from '../model/person';
import { IInvoicingServiceList } from '../model/invoicing-service-list';
import { of } from 'rxjs/observable/of';
import { SpinnerService } from './spinner.service';

@Injectable()
export class InvoicingServiceService {

  /**
   *
   * @type {string}
   */
  private invoicingServiceSlugUrl: string = environment.apiUrl + '/v1/invoicing-services-data';

  /**
   *
   * @type {string}
   */
  private invoicingServiceValidationUrl: string = environment.apiUrl + '/v1/invoicing-service-validation';

  /**
   *
   * @type {string}
   */
  private invoicingServicesUrl: string = environment.apiUrl + '/v1/invoicing-services';

  /**
   *
   * @type {string}
   */
  private invoicingServiceAuthorizedUrl = environment.apiUrl + '/v1/person/invoicing-services';

  /**
   *
   * @param {HttpClient} http
   * @param {SpinnerService} spinnerService
   */
  constructor(private http: HttpClient,
              private spinnerService: SpinnerService,) {
  }

  /**
   *
   * @param {IInvoicingService} invoicingService
   */
  validateInvoicingService(invoicingService: IInvoicingService): Observable<any> {
    this.spinnerService.setSpinner(true);
    return this.http.post(this.invoicingServiceValidationUrl, invoicingService)
      .map(response => {
        this.spinnerService.setSpinner(false);
        return response;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   * @return {Observable<IInvoicingService>
   * @param {string} signedXml
   */
  saveInvoicingService(signedXml: string): Observable<IInvoicingService> {
    this.spinnerService.setSpinner(true);
    return this.http.post(this.invoicingServicesUrl, { 'xml_signed': signedXml })
      .map(response => {
        this.spinnerService.setSpinner(false);
        return response;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   *
   * @returns {Observable<IInvoicingServiceList>|null}
   * @param searchedText
   */
  searchInvoicingServices(searchedText: string): Observable<IInvoicingService[]> {
    searchedText = searchedText.trim();
    if (searchedText === '') {
      return of([]);
    }

    const options = searchedText ? { params: new HttpParams().set('searchedText', searchedText) } : {};
    return this.http.get(this.invoicingServicesUrl, options)
      .map(response => {
        return response;
      }).catch(error => {
        return Observable.throw(error);
      });
  }

  /**
   *
   * @param {string} identifier
   * @return {Observable<IInvoicingService>}
   */
  getInvoicingService(identifier: string): Observable<IInvoicingService> {
    this.spinnerService.setSpinner(true);
    return this.http.get(this.invoicingServicesUrl + '/' + identifier)
      .map(response => {
        this.spinnerService.setSpinner(false);
        return response;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   *
   * @param {IPerson} person
   * @returns {Observable<IInvoicingService>}
   */
  updateInovicingService(person: IPerson): Observable<IInvoicingService> {
    return this.http.patch(this.invoicingServicesUrl + '/' + person.identifier, person)
      .map(response => {
        return response;
      })
      .catch(error => {
        return Observable.throw(error);
      });
  }

  /**
   *
   * @param {string} slug
   * @returns {Observable<IInvoicingService>}
   */
  getDataInvoicingServiceSlug(slug: string) {
    this.spinnerService.setSpinner(true);
    return this.http.get(this.invoicingServiceSlugUrl + '/' + slug)
      .map(response => {
        this.spinnerService.setSpinner(false);
        return response;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   *
   * @returns {Observable<IInvoicingService>}
   */
  getInvoicingServicesAsAuthorized(): Observable<IInvoicingService[]> {
    this.spinnerService.setSpinner(true);
    return this.http.get(this.invoicingServiceAuthorizedUrl)
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res as IInvoicingService[];
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/invoicing-service.service.ts